var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',{staticClass:"advocay-template"},[_c('Row',{attrs:{"type":"flex","justify":"center"}},_vm._l((_vm.menuList),function(menu,k){return _c('Col',{key:k,attrs:{"span":24}},[_c('MenuListComponent',{attrs:{"item":menu}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }